module.exports = __webpack_public_path__ + "static/media/Transportbikefromvizag.ec719238.jpg";